function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from "react";
import { GraphComponent } from "./GraphComponent";
import { ErrorBoundary } from "react-error-boundary";
export var ViewBuilderV2 = /*#__PURE__*/memo(function ViewBuilderV2(props) {
  if (props.list.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", null, props.list.map(function (item, index) {
    return /*#__PURE__*/React.createElement(GraphDesign, _extends({
      key: "".concat(item.screen_name).concat(index)
    }, item));
  }));
});
export function GraphDesign(props) {
  return /*#__PURE__*/React.createElement("div", null, props.section_list.map(function (item, index) {
    return /*#__PURE__*/React.createElement(GraphSection, _extends({
      key: "".concat(item.section_name).concat(index)
    }, item));
  }));
}
export function GraphSection(props) {
  return /*#__PURE__*/React.createElement("div", null, props.component_list.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ErrorBoundary, {
      fallback: /*#__PURE__*/React.createElement("p", null, "Something went wrong"),
      key: "".concat(item.interface_id).concat(index)
    }, /*#__PURE__*/React.createElement(GraphComponent, _extends({
      key: "".concat(item.interface_id).concat(index),
      component_index_id: index + ""
    }, item)));
  }));
}